import { connectedAccountsStore } from '../../store/store';
import { mutatorAction } from 'satcheljs';
export var updateEditAltUsername = mutatorAction('updateEditAltUsername', function (username) {
    var store = connectedAccountsStore();
    store.editAccountState.altUsername = username;
});
//# sourceMappingURL=updateEditAltUsername.js.map